/**
 * Safe date formatters.
 *
 * - Returns `null` when the input is null / undefined / empty.
 * - Returns the raw input as a string when `new Date(...)` can't parse it
 *   (e.g. Java `LocalDateTime` format `"2026-04-19 14:23:45"` — space
 *   instead of `T` — which JS does not accept as ISO). This matches the
 *   original `<TextField source="date"/>` behaviour so users at least see
 *   the raw value instead of a dash.
 * - Returns a locale-formatted string when the input parses cleanly.
 */

export const toDate = (v) => {
    if (v == null || v === '') return null;
    const d = v instanceof Date ? v : new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
};

const rawFallback = (v) => (v == null || v === '' ? null : String(v));

export const formatDate = (v, options) => {
    if (v == null || v === '') return null;
    const d = toDate(v);
    if (!d) return rawFallback(v);
    try {
        return d.toLocaleDateString(undefined, options);
    } catch {
        return rawFallback(v);
    }
};

export const formatDateTime = (v, options) => {
    if (v == null || v === '') return null;
    const d = toDate(v);
    if (!d) return rawFallback(v);
    try {
        return d.toLocaleString(undefined, options);
    } catch {
        return rawFallback(v);
    }
};

export const formatShortDate = (v) => formatDate(v, {month: 'short', day: 'numeric', year: 'numeric'});
